import React, { useState, useEffect } from "react";
import { animateScroll as scroll } from "react-scroll";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom"; 
import { getAuthToken, clearAuthSession } from "../../api/authSession";
import DIETLogo from "../Logo/DIET_Logo.png";
import ACMLogo from "../Logo/DIET_ACM_Logo.png";
import "./Header.css";

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false); 
  const location = useLocation(); 
  const navigate = useNavigate();

  const isTokenPresent = Boolean(getAuthToken());

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const onNavClick = () => {
    setIsMenuOpen(false);
  };

  const toggleMenu = () => { 
    setIsMenuOpen(prev => !prev);
  };

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to log out of the admin console?")) {
      clearAuthSession();
      navigate("/login");
      window.location.reload();
    }
  };
  
  const navItems = [
    { id: "home", label: "Dashboard", path: "/" },
    { id: "events", label: "Events", path: "/events" },
    { id: "ourteam", label: "Our Team", path: "/ourteam" },
    { id: "blogs", label: "Blogs", path: "/blogs" },
    { id: "calendar", label: "Calendar", path: "/calendar" },
    { id: "gallery", label: "Gallery", path: "/gallery" },
    { id: "benefits", label: "Benefits", path: "/benefits" },
    { id: "popup", label: "Popup", path: "/popup" },
  ];

  return (
    <header className={`main-header ${scrolled ? "scrolled" : ""}`}>
      <div className="logo-container">
        <a href="https://diet.edu.in/" target="_blank" rel="noopener noreferrer">
          <img src={DIETLogo} alt="DIET Logo" className="diet-logo" />
        </a>
        <RouterLink to="/" onClick={() => { onNavClick(); scroll.scrollToTop(); }} className="acm-brand-link">
          <img src={ACMLogo} alt="ACM Logo" className="acm-logo" />
          <span className="admin-badge">ADMIN</span>
        </RouterLink>
      </div>

      {/* HAMBURGER MENU BUTTON */}
      <button 
        className="menu-button" 
        onClick={toggleMenu} 
        aria-expanded={isMenuOpen}
        aria-label="Toggle Navigation Menu"
      >
        <i className={isMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
      </button>

      <nav className={`nav-links ${isMenuOpen ? "open" : ""}`}>
        {isTokenPresent && navItems.map((item) => {
          const isActive = item.path === "/" 
            ? location.pathname === "/" 
            : location.pathname.startsWith(item.path);

          return (
            <RouterLink
              key={item.id}
              to={item.path}
              className={`nav-item-link ${isActive ? "active" : ""}`}
              onClick={onNavClick}
            >
              {item.label}
            </RouterLink>
          );
        })}

        {isTokenPresent ? (
          <button className="logout-nav-btn" onClick={handleLogout} title="Logout">
            <i className="fas fa-sign-out-alt"></i> Logout
          </button>
        ) : (
          <RouterLink to="/login" className="login-nav-btn" onClick={onNavClick}>
            <i className="fas fa-user-lock"></i> Login
          </RouterLink>
        )}
      </nav>
    </header>
  );
}

export default Header;